import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getHotels() {
    yield* takeEvery("HOTELS/FETCH", function* (action) {
        try {
            const result = yield call(({ idHotel }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/hotels${idHotel ? `/${idHotel}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { hotels, hotel } = result;
                yield put({ type: 'HOTELS/SET', hotels });
                if (action.idHotel) yield put({ type: 'HOTEL/SET', hotel });
            } else {
                yield put({ type: 'HOTELS/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'ALUMNI/FETCH_FAILED', e });
        }
    });
}

//HOTELS/SEASON/FETCH
export function* getHotelsBySeason() {
    yield* takeEvery("HOTELS/SEASON/FETCH", function* (action) {
        try {
            const result = yield call(({ idSeason }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/hotels/by_season/${idSeason}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { hotels } = result;
                yield put({ type: 'HOTELS/SEASON/SET', hotels });                
            } else {
                yield put({ type: 'HOTELS/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'ALUMNI/FETCH_FAILED', e });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/hotels.js